// Define flags
export const DEFAULT_CHANNEL = true;
export const DEFAULT_CHANNEL_VALUE = 1;
export const MULTIPLE_CAT_PER_VIDEO = false;
export const SHOW_OVERVIEW_DASHBOARD = true;
export const SHOW_REALTIME_DASHBOARD = true;
export const SHOW_SUBSCRIBERS = true;
export const SHOW_ADMIN_USERS = false;
export const SHOW_EPG = false;
export const SHOW_CONTENT_CATEGORIES = false;
export const SUBCONTENT_CATEGORIES = false;
export const SHOW_CONTENT_VIDEOS = true;
export const SUBCONTENT_SEQUENCE = false;
export const SHOW_TABS = false;
export const SHOW_MANAGE_SEQUENCE = false;
export const SHOW_REPORTS_OVERVIEW_VIDEOS = true;
export const SHOW_REPORTS_OVERVIEW_ADS = false;
export const SHOW_REPORTS_LIVE_USERS = true;
export const SHOW_REPORTS_WATCH_SESSIONS = true;
export const SHOW_REPORTS_APP_SESSIONS = true;
export const SHOW_REPORTS_CONTENT_CREATOR = true;
export const SHOW_REPORTS_VIDEO_WATCH_SESSIONS = true;
export const SHOW_TOTAL_WATCHED_TIME = true;

// Define commonly used constants
export const LS_ADMIN_USER_ID = '__etf_admin_i';
export const LS_ADMIN_USER_AUTH_TOKEN = '__etf_admin_t';
export const LS_ADMIN_USER_NAME = '__etf_admin_n';
export const LS_ADMIN_USER_EMAIL = '__etf_admin_e';
export const LS_ADMIN_USER_ROLE = '__etf_admin_r';

export const STATUS_LABELS = {
  0: 'Inactive',
  1: 'Active',
  2: 'Deleted',
  5: 'Requested Delete',
  11: 'Pending Verification',
  12: 'Cancellation Applied',
};
export const ACCEPTANCE_LABELS = {
  0: 'No',
  1: 'Yes',
};

export const STATUS_COLORS = {
  0: 'error',
  1: 'success',
  2: 'error',
  5: 'warning',
  11: 'warning',
  12: 'warning',
};

export const CONTENT_ALIAS = {
  CHANNEL_SINGULAR: 'Channel',
  CHANNEL_PLURAL: 'Channels',
  CATEGORY_SINGULAR: 'Category',
  CATEGORY_PLURAL: 'Categories',
  VIDEO_SINGULAR: 'Video',
  VIDEO_PLURAL: 'Videos',
  CONTENT: 'Content',
  AD_SINGULAR: 'Ad',
  AD_PLURAL: 'Ads',
  USER_SINGULAR: 'User',
  USER_PLURAL: 'Users',
};

export const CATEGORY_OPTIONS = {
  old: {
    shorthand: 'old',
    title: 'OLD TESTAMENT STUDY',
    displayText: 'Old Testament',
    path: 'old',
  },
  new: {
    shorthand: 'new',
    title: 'NEW TESTAMENT STUDY',
    displayText: 'New Testament',
    path: 'new',
  },
};

export const ADMIN_USER_ROLE = {
  ADMIN: 'ADMIN',
  CONTENT_OWNER: 'CONTENT_OWNER',
};

export const ACTIONS = {
  CREATE: {
    value: 'create',
    label: 'Create New',
  },
  EDIT: {
    value: 'update',
    label: 'Edit',
  },
  VIEW: {
    value: 'view',
    label: 'View',
  },
  DELETE: {
    value: 'delete',
    label: 'Delete',
  },
  CHANGE_PASSWORD: {
    value: 'change_password',
    label: 'Change Password',
  },
  ASSIGN_CATEGORIES: {
    value: 'assign_books',
    label: `Assign ${CONTENT_ALIAS.CATEGORY_PLURAL}`,
  },
  UPLOAD_ASSETS: {
    value: 'upload_assets',
    label: 'Upload Assets',
  },
  UPLOAD_BANNER: {
    value: 'upload_banner',
    label: 'Upload Banner',
  },
  DOWNLOAD: {
    value: 'download',
    label: 'Download',
  },
};

// Place it in CSS file
export const FOCUS_PALETTE_BGCOLOR = 'rgba(255, 255, 255, 0.25)';

export const EPG_SCHEDULER_GAP_HEIGHT = 80;

// If you change one block timing gap (currently 30 minutes) then you also need change below variable value
export const TIME_GAP_OF_EPG_BLOCK_IN_SECONDS = 1799;
